import { useTranslation } from 'react-i18next'

const ForeignDadEnd = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="foreigndad-end-title"
      {...props}
    >
      <title id="foreigndad-end-title">{t('antagonists:foreigndad:components:end')}</title>
      <defs>
        <clipPath id="foreigndad-b">
          <path
            d="M1549.87 407.87s7.52-6.64 22.41 13.2c14.89 19.86 34.67 55.75 34.67 55.75s24.55-31.31 34.47-45.21c9.92-13.9 15.66-34.68 15.66-34.68s44.68 16.38 61.06 22.83c16.38 6.46 30.17 14.87 33.65 22.82 3.48 7.95-24.11 76.4-25.6 97.74-1.49 21.34 12.11 115.81 12.08 137.65-.03 22.18 18.53 31.69 6.82 45.59-16.88 20.04-2.46 93.73-2.46 93.73s-77.05 12.29-132.14 16.26c-55.1 3.97-109.26-7.55-109.26-7.55s12.44-51.17 10.01-82.83c-2.42-31.4-11.88-42.2-12.88-59.57-.99-17.38 8.05-84.53.81-128.8-4.76-29.02-45.86-103.44-30.72-117.1 8.11-7.32 22.68-14.28 37.95-17.14 19.6-3.68 43.46-12.72 43.46-12.72h.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="foreigndad-c">
          <path
            d="M1563.03 254.4c-8.49 5.86-.29 28.14-.29 28.14s-5.58 1.46-6.75 10.25c-1.17 8.8-.59 56.56 2.64 63.3 3.22 6.75 22.56 32.83 30.78 38.98 8.2 6.15 25.8 4.98 34.88-1.76 9.08-6.75 32.24-31.95 33.12-40.44.88-8.49 2.05-40.74 2.05-46.02s-3.81-10.85-6.75-14.66c-2.93-3.81-5.27-7.63-5.27-7.63s12.9-18.76 4.1-27.25c-3.93-3.8-25.2 5.58-42.49 4.98s-38.48-13.11-46.02-7.91l-.02.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <style>
          {
            '.d{fill:none}.e{fill:#00101f}.f{fill:#f1f1f3}.g{fill:#e2ebf4}.h{fill:#9d8042}.i{fill:#c9936d}.j{fill:#11242f}.k{fill:#404b51}.l{fill:#272a3e}.m{fill:#2f2b39}.n{fill:#4f4e47}.o{clip-path:url(#foreigndad-c)}.p{clip-path:url(#foreigndad-b)}'
          }
        </style>
      </defs>
      <path
        d="M1760.19 752.13s-7.34 19.32-12.81 22.59c-5.47 3.27-18.37 17.36-25.1 24.64-6.73 7.26-33.8 25.83-33.8 25.83s1.88 9.19 12.11 5.56c10.24-3.65 18.49-10.63 18.49-10.63s4.6 13.57 21.07 16.91 27.98-.79 27.98-.79 7.54-9.54 12.55-20.16c5.01-10.6 9.07-38.8 9.07-38.8l-29.55-25.14h-.02Z"
        style={{
          fill: '#9d8042',
        }}
      />
      <path
        d="M1694 430.95c-30.38 20.28 27.91 107.85 48.83 138.76 22.95 33.92 39.3 71.28 52.55 79.24 13.25 7.96 56.04 1.93 59.22-20.36 3.18-22.29-21.71-65.61-43.69-103.29-20.96-35.93-53.19-76.89-62.73-87.49-9.54-10.62-43.05-14.28-54.19-6.85l.02-.02Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        d="M1784.82 612.61s-10.7 67.74-17.59 94.98c-6.9 27.25-18.14 63.85-18.14 63.85s9.66 7.95 22.83 15.59c13.17 7.64 18.99 13.1 18.99 13.1l14.1-32.34s14.55-12.35 20.87-37.28c6.32-24.95 26.49-76.34 27.06-87.99.56-11.65 5.12-22.35-1.22-38.19-5.53-13.81-62.91-16.74-66.91 8.31v-.02Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        d="M1491.52 759.43s9.33 18.46 15.12 21.12c5.77 2.67 20.08 15.34 27.56 21.86 7.46 6.52 36.34 22.12 36.34 22.12s-.9 9.34-11.45 6.81c-10.56-2.55-19.51-8.63-19.51-8.63s-3.14 13.98-19.17 19.04c-16.03 5.06-30.54 7.22-30.54 7.22s-10.97-26.57-14.28-37.83c-3.9-13.28-10.8-23.58-10.8-23.58l26.74-28.12Z"
        style={{
          fill: '#9d8042',
        }}
      />
      <path
        d="M1509.62 420.1s-3.8 125.04-21.34 158c-19.25 36.16-30.28 73.09-42.61 82.4-12.34 9.31-55.53 7.82-61.04-14.01-5.51-21.83 11.26-65.64 29.15-105.43 17.06-37.93 32.28-84.31 39.88-96.39 10.7-17 55.97-24.57 55.97-24.57Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        d="M1452.33 623.26s14.99 68.79 24.72 95.16c9.72 26.37 24.37 55.62 24.37 55.62s-5.55 4.48-17.84 13.48c-12.29 8.98-17.56 17.71-17.56 17.71l-15.45-22.8s-17.77-7.54-26.69-31.68c-8.92-24.14-27.42-66.62-32.4-77.17-5.82-12.38-14.16-32.94-6.18-45.5 7.96-12.56 60.43-29.31 67.04-4.8v-.02Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        d="M1562.3 345.13s1.76 39.3-3.16 56.85c-4.91 17.55-15.44 46.32-15.44 46.32s58.61 81.43 58.96 80.37c.35-1.05 66.68-95.47 65.98-96.51s-12.99-19.31-15.44-37.9c-2.46-18.59-3.16-39.67-3.16-39.67l-87.73-9.48-.02.03Z"
        style={{
          fill: '#9d8042',
        }}
      />
      <path
        d="M1549.87 407.87s7.52-6.64 22.41 13.2c14.89 19.86 34.67 55.75 34.67 55.75s24.55-31.31 34.47-45.21c9.92-13.9 15.66-34.68 15.66-34.68s44.68 16.38 61.06 22.83c16.38 6.46 30.17 14.87 33.65 22.82 3.48 7.95-24.11 76.4-25.6 97.74-1.49 21.34 12.11 115.81 12.08 137.65-.03 22.18 18.53 31.69 6.82 45.59-16.88 20.04-2.46 93.73-2.46 93.73s-77.05 12.29-132.14 16.26c-55.1 3.97-109.26-7.55-109.26-7.55s12.44-51.17 10.01-82.83c-2.42-31.4-11.88-42.2-12.88-59.57-.99-17.38 8.05-84.53.81-128.8-4.76-29.02-45.86-103.44-30.72-117.1 8.11-7.32 22.68-14.28 37.95-17.14 19.6-3.68 43.46-12.72 43.46-12.72h.02Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <g
        style={{
          clipPath: 'url(#foreigndad-b)',
        }}
      >
        <path
          d="M1592.55 463.82s-.59 53.37 1.79 104.32c2.4 50.97 14.99 115.72 14.99 142.7s-4.19 77.95-4.19 77.95l24.58 1.2s5.39-37.17 1.79-85.15c-3.6-47.96-14.36-109.91-15.56-135.1-1.2-25.19-2.43-117.93-2.43-117.93l-20.98 11.99v.03Z"
          style={{
            fill: '#e2ebf4',
          }}
        />
      </g>
      <path
        d="M1607.71 215.57c-16.41-.21-53.05 17.59-56.56 31.66-3.52 14.07-1.17 56.86-1.17 56.86l114.88-.29s6.75-31.07-1.17-51.58c-7.91-20.51-33.41-36.34-55.98-36.64v-.02Z"
        style={{
          fill: '#404b51',
        }}
      />
      <path
        d="M1655.35 305.69s10.56-12.61 16.12-10.25c5.58 2.34 1.17 17.29-.88 24.03-2.05 6.75-5.58 20.51-10.25 20.22-4.69-.29-14.66-.29-14.66-.29l9.68-33.71ZM1558.91 301.01s-10.56-12.61-16.12-10.25c-5.58 2.34-1.17 17.29.88 24.03 2.05 6.75 5.58 20.51 10.25 20.22 4.69-.29 14.66-.29 14.66-.29l-9.68-33.71Z"
        style={{
          fill: '#9d8042',
        }}
      />
      <path
        d="M1563.03 254.4c-8.49 5.86-.29 28.14-.29 28.14s-5.58 1.46-6.75 10.25c-1.17 8.8-.59 56.56 2.64 63.3 3.22 6.75 22.56 32.83 30.78 38.98 8.2 6.15 25.8 4.98 34.88-1.76 9.08-6.75 32.24-31.95 33.12-40.44.88-8.49 2.05-40.74 2.05-46.02s-3.81-10.85-6.75-14.66c-2.93-3.81-5.27-7.63-5.27-7.63s12.9-18.76 4.1-27.25c-3.93-3.8-25.2 5.58-42.49 4.98s-38.48-13.11-46.02-7.91l-.02.02Z"
        style={{
          fill: '#9d8042',
        }}
      />
      <g
        style={{
          clipPath: 'url(#foreigndad-c)',
        }}
      >
        <path
          d="M1590.69 349.61c-8.67 2.11-10.48 6.5-12.53 8.26s-3.39 4.09-6.02 4.38c-2.64.29-7.11-16.76-6.96-24.26.09-4.31-2.57-24.22-6.14-36.28-1.66-5.59-7.66-9.53-7.66-9.53s-6.2 43.39-6.2 44.27 7.03 51.88 7.03 51.88l48.95 29.9 33.12-5.58s38.69-50.71 37.51-51c-1.17-.29-7.99-63.47-7.99-63.47s-6.38.85-9.31 9.94-7.28 52.72-15.66 55.16c-3.1.9-8.26-9.97-14.81-13.1-6.35-3.04-13.25.56-17.94.85-4.69.29-12.7-2.08-15.37-1.43h-.02Z"
          style={{
            fill: '#404b51',
          }}
        />
      </g>
      <path
        d="M1595.18 284.16s-19.49 3.69-24.14 4.76c-4.65 1.06-7.22 9.86-7.22 9.86l3.13 2.8s3.01-4.83 10.01-5.64c7-.81 22.91-3.9 22.91-3.9l-4.69-7.87ZM1611.43 291.32l1.88 7.7s21.79-8.39 24.58-7.66c2.8.73 7.7 1.69 7.7 1.69l.77-6.08s-4.57-4.28-11.23-4.97c-6.65-.67-23.71 9.3-23.71 9.3v.02Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M1602.47 374.86c9.12 1.12 23.09-6.73 23.93-8.8.84-2.05-1.41-9.39-10.03-10.85-8.61-1.46-9.45 2.05-11.41 2.05s-4.45-1.76-9.18-2.34c-4.72-.59-6.73 2.95-7.9 4.66-2.11 3.08.05 7.75 1.84 9.53s8.02 5.17 12.75 5.74Z"
        style={{
          fill: '#c9936d',
        }}
      />
      <path
        d="M1589.1 305.98c-2.63-.74-4.98.52-5.61 3.13s.76 4.13 3.08 4.94c2.73.96 4.8-.29 5.71-2.9.64-1.85-.49-4.41-3.19-5.17Z"
        style={{
          fill: '#2f2b39',
        }}
      />
      <path
        style={{
          fill: '#2f2b39',
        }}
        d="m1576.89 308.88 14.23-3.95-.67-5.42-16.63 5.06 3.07 4.31zM1630.21 307.04c2.63-.74 4.98.52 5.61 3.13s-.76 4.13-3.08 4.94c-2.73.96-4.8-.29-5.71-2.9-.64-1.85.49-4.41 3.19-5.17Z"
      />
      <path
        style={{
          fill: '#2f2b39',
        }}
        d="m1636.19 309.43-14.12-4.06 1.03-5.18 15.74 4.69-2.65 4.55z"
      />
      <path
        d="M1562.44 372.5s-.67 11.99 1.28 19.64c2.31 9.16 43.28 84.57 43.28 84.57s23.4-33.68 30.76-44.92c7.37-11.23 14.31-55.16 14.31-55.16l9.16 12.62s2.86 22.53 6.37 40.43c3.51 17.9 2.05 41.67 2.05 41.67l-29.38-28.77-35.38 43.18-29.02-43.39-37.19 26.18.5-58.55 17.5-31.89 5.76-5.61Z"
        style={{
          fill: '#e2ebf4',
        }}
      />
      <path
        d="M1512.56 748.78s70.84 17.73 106.05 14.96c35.21-2.76 122.1-23.56 122.1-23.56l2.35 37.42s30.52 36.04 34.29 61.91c3.75 25.87 8.45 221.77 4.22 243.95-4.22 22.18-7.52 98.41-8.92 122.45-1.41 24.02-10.8 177.88-10.8 177.88s-3.28 12.02-14.55 13.85c-11.27 1.85-55.88-11.55-55.88-11.55s-7.98-67.92-7.52-108.58c.47-40.65 9.86-122.9 7.05-135.37-2.81-12.47-15.02-104.41-26.3-139.99-11.27-35.58-27.24-74.85-41.32-114.58-14.08-39.74-110.75-138.79-110.75-138.79h-.03Z"
        style={{
          fill: '#11242f',
        }}
      />
      <path
        d="M1508.26 776.67s-19.45 42.54-28.94 61.74c-6.79 13.72 30.35 159.12 32.69 192.39 2.35 33.27 15.5 107.65 14.55 123.83-.94 16.16 12.69 125.21 18.32 154.77 5.64 29.56 21.13 85.94 21.13 85.94s10.8 4.16 22.07 5.09c11.27.93 36.63-12.47 36.63-12.47s6.11-41.58 2.35-84.09c-3.75-42.51-23.02-142.77-20.19-163.1 2.81-20.33 16.44-115.5 18.78-141.85 2.35-26.34 16.44-204.68 16.44-204.68l-101.44-37.42-31.46-10.16-.94 30.03v-.03Z"
        style={{
          fill: '#11242f',
        }}
      />
      <path
        d="M1683.64 750.9s1.49 11.14 2.81 19.57 1.32 19.14 1.32 19.14l9.56-1.29s-.65-11.03-1.66-21.09c-.99-10.06-2.98-17.67-2.98-17.67l-9.05 1.34ZM1552.53 755.43s-1.29 10.5-2.61 18.94c-1.32 8.43-1.32 19.14-1.32 19.14l-9.56-1.29s.65-11.03 1.66-21.09c.99-10.06 3.05-17.29 3.05-17.29l8.8 1.6-.02-.02Z"
        style={{
          fill: '#00101f',
        }}
      />
      <path
        d="M1621.49 769.65c3.51.23 5.36 3.1 5.32 5.01-.06 2.87-.71 5.88-5.86 5.97-3.74.06-5.71-2.43-5.71-6.05 0-2.55 2.64-5.18 6.27-4.95l-.02.02Z"
        style={{
          fill: '#4f4e47',
        }}
      />
    </svg>
  )
}

export default ForeignDadEnd
